
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "link": "link-8ac96668"
};
exports.styleSource = ".link-8ac96668{position:relative;text-decoration:none;cursor:pointer}";
exports.default = exports.styles;
            
module.moduleType = "style";
